import React from 'react';
import {
  PEDA_CATEGORY_KEYS,
  PEDA_CATEGORY_LABELS,
  type PedaCategoryKey,
} from '../../systems/peda-categories';
import styles from './scenario-studio.module.css';

interface PedaCategorySelectProps {
  value?: PedaCategoryKey | '';
  onChange: (value: PedaCategoryKey | undefined) => void;
  required?: boolean;
  label?: string;
  id?: string;
}

export const PedaCategorySelect: React.FC<PedaCategorySelectProps> = ({
  value = '',
  onChange,
  required = false,
  label = 'Catégorie PEDA',
  id,
}) => (
  <div className={styles.field}>
    <label htmlFor={id}>{label}</label>
    <select
      id={id}
      className={styles.select}
      value={value}
      required={required}
      onChange={(e) => onChange((e.target.value || undefined) as PedaCategoryKey | undefined)}
    >
      <option value="">— Sélectionner —</option>
      {PEDA_CATEGORY_KEYS.map((key) => (
        <option key={key} value={key}>
          {PEDA_CATEGORY_LABELS[key]}
        </option>
      ))}
    </select>
  </div>
);
